import { TextLink } from '@oneaudi/unified-web-components';
import { useState } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { CompareLayerWrapper } from '~/app/pages/configurator/components/compare-layer-wrapper';
import { Dialog } from '~/components/dialog';

export const DriveTrainCompare = () => {
	const { i18n } = useI18n();

	const [isOpen, setIsOpen] = useState<boolean>(false);

	return (
		<div>
			<Dialog
				classNameDialog="drive-train-compare-dialog"
				triggerElement={
					<TextLink variant={'standalone'} size={'sm'} onClick={() => setIsOpen(true)}>
						{i18n('ngc.dialogs.comparison.driveTrain.trigger')}
					</TextLink>
				}
				onCloseButtonClick={() => setIsOpen(false)}
				open={isOpen}>
				{isOpen && (
					<CompareLayerWrapper
						key="drive-train-compare"
						setIsOpen={setIsOpen}
						open={isOpen}
						config={{
							selectedTab: 'technicalData',
							isCompareActive: true,
						}}
					/>
				)}
			</Dialog>
		</div>
	);
};
